import CustomModal from "../CustomModal";

function EditMemberStatsModal({
  isOpen,
  handleCloseModals,
  memberData,
  handleInputChange,
  handleSave2,
}) {
  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={handleCloseModals}
      contentLabel="Gym info label"
      className="add-admin-modal"
    >
      <div className="form-container">
        <div className="inner-form">
          <div className="add-staff-head">
            <h2>Update Member stats</h2>
          </div>
          <div className="form-input">
            <label htmlFor="weight">Weight</label>
            <input
              id="weight"
              name="weight"
              value={memberData.weight}
              type="number"
              onChange={handleInputChange}
              required
            />

            <label htmlFor="height">Height</label>
            <input
              id="height"
              name="height"
              value={memberData.height}
              type="number"
              onChange={handleInputChange}
              required
            />

            <label htmlFor="bodySize">Body Size</label>
            <input
              id="bodySize"
              name="bodySize"
              value={memberData.bodySize}
              type="number"
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
      </div>
      <div className="modal-button">
        <button onClick={handleCloseModals}>Cancel</button>
        <button
          style={{ backgroundColor: "#0473BD", color: "white" }}
          onClick={handleSave2}
        >
          Save
        </button>
      </div>
    </CustomModal>
  );
}

export default EditMemberStatsModal;
